import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const PageHeading = ({ text, className }) => {
  return (
    <h1 className={cn('page-heading', className)}>
      <span className="page-heading__text">{text}</span>
    </h1>
  );
};

PageHeading.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

PageHeading.viewModelMeta = 'ignore';

export default PageHeading;
